import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React from 'react';
import constant from '../../../../utils/constant';
import { useDefaultComponentValue } from '../../../../utils/useDefaultComponentValue';
const COMPONENT_NAME = 'FormGroupLabel';
export const positionConstants = constant({
    LEFT: 'left',
    RIGHT: 'right'
});
const FormGroupLabel = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { className, position = positionConstants.LEFT, children } = props;
    return /*#__PURE__*/ React.createElement("div", {
        className: cx('FormGroup-label', {
            'FormGroup-label--pushRight': position === positionConstants.RIGHT
        }, className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: cx('FormGroup-labelContent')
    }, children));
};
FormGroupLabel.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    position: PropTypes.oneOf(positionConstants.values())
};
FormGroupLabel.positions = positionConstants;
export default FormGroupLabel;
